import { useCallback, useRef, useState } from 'react';

import type {
  IMultiSession,
  IMultiSessionsContextValue,
} from './MultiSessionsContext';
import { storageFactory } from '~/lib/storage';
import { MultiSessionsContext } from './MultiSessionsContext';

const STORAGE_KEY = 'currentSessionId';

export type IMultiSessionsProviderOptions = {
  children?: React.ReactNode;
};

export const MultiSessionsProvider: React.FC<IMultiSessionsProviderOptions> = (
  props,
) => {
  const { children } = props;
  const localStorageRef = useRef(storageFactory('local')());
  const sessionStorageRef = useRef(storageFactory('session')());
  const localStorageValue = localStorageRef.current.get<string>(STORAGE_KEY);
  const sessionStorageValue =
    sessionStorageRef.current.get<string>(STORAGE_KEY);
  const [currentId, setCurrentId] = useState<string | undefined>(
    sessionStorageValue ?? localStorageValue,
  );

  const add = useCallback(({ sessionId, isCurrent }: IMultiSession) => {
    void localStorageRef.current.set(STORAGE_KEY, sessionId);
    void sessionStorageRef.current.set(STORAGE_KEY, sessionId);

    if (isCurrent) {
      setCurrentId(sessionId);
    }
  }, []);

  const contextValue: IMultiSessionsContextValue = {
    currentId,
    add,
  };

  return (
    <MultiSessionsContext.Provider value={contextValue}>
      {children}
    </MultiSessionsContext.Provider>
  );
};
